import { useMemo, useCallback } from 'react'
import { useHistory, useLocation } from 'react-router'

const useUrlParams = <T extends Record<string, string>>(): [urlParams: T | Record<string, never>, setUrlParams: (urlParams: T) => void] => {
  const history = useHistory()
  const location = useLocation()

  const urlParams = useMemo<T | Record<string, never>>(() => {
    const entries = new URLSearchParams(location.search).entries()
    const obj = {}
    for (const [key, value] of entries) {
      obj[key] = value
    }
    return obj
  }, [location.search])

  const setUrlParams = useCallback(
    (urlParams: T) => {
      const queryString = new URLSearchParams(urlParams)
      history.push(`${location.pathname}?${queryString}`)
    },
    [history, location.pathname]
  )

  return [urlParams, setUrlParams]
}

export default useUrlParams
